var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentIds.length)?_c('div',{staticClass:"c-box"},_vm._l((_vm.studentIds),function(studentId,i){return _c('student-profile',{key:studentId,attrs:{"studentId":studentId,"with-divider":i !== _vm.studentIds.length - 1}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }